import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CashDrawerList } from './list';
import { OpenShiftModal } from './OpenShiftModal';

export const CashDrawerPage = () => {
  const { t } = useTranslation();
  const [openModalOpen, setOpenModalOpen] = useState(false);

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenModalOpen(true)}
          sx={{ borderRadius: 2 }}
        >
          {t('cashDrawer.openShiftModal.title')}
        </Button>
      </Box>
      <CashDrawerList />
      <OpenShiftModal open={openModalOpen} onClose={() => setOpenModalOpen(false)} />
    </>
  );
};

export { CashDrawerList } from './list';
export { CashDrawerShow } from './show';
export { OpenShiftModal } from './OpenShiftModal';
export { CloseShiftModal } from './CloseShiftModal';
export { CashMovementModal } from './CashMovementModal';

export default CashDrawerPage;
